import { render } from "./Minicart.vue?vue&type=template&id=4f46ee28"
import script from "./Minicart.vue?vue&type=script&lang=js"
export * from "./Minicart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__